import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class CefrlExamService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  state(sectionUniqid: string) {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}cefrl-exam/state/${sectionUniqid}`).toPromise();
  }

  start(sectionUniqid: string) {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint()}cefrl-exam/start/${sectionUniqid}`, {}).toPromise();
  }

  answer(values: any) {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint()}cefrl-exam/answer`, values).toPromise();
  }

  result(sectionUniqid: string) {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}cefrl-exam/result/${sectionUniqid}`).toPromise();
  }

}
